import { render, staticRenderFns } from "./EnhancedTreatmentPlan.vue?vue&type=template&id=2b0da216&scoped=true"
import script from "./EnhancedTreatmentPlan.vue?vue&type=script&lang=js"
export * from "./EnhancedTreatmentPlan.vue?vue&type=script&lang=js"
import style0 from "./EnhancedTreatmentPlan.vue?vue&type=style&index=0&id=2b0da216&prod&scoped=true&lang=css"
import style1 from "./EnhancedTreatmentPlan.vue?vue&type=style&index=1&id=2b0da216&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0da216",
  null
  
)

export default component.exports